import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BoostrapAthleteBiographyComponent } from './boostrap-athlete-biography/boostrap-athlete-biography.component';

const routes: Routes = [{
  path:'',
  component:BoostrapAthleteBiographyComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AthleteBiographyRoutingModule { }
